export default (function (_ref) {
  var service = _ref.service,
    request = _ref.request;
  return {
    deleteLifestyleComment: function deleteLifestyleComment() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/subject/deleteComment",
        method: "post",
        data: data
      });
    },
    getMemberUserList: function getMemberUserList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v1/admin/member/get",
        method: "get",
        params: data
      });
    },
    auditMemberUser: function auditMemberUser() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "api/v1/admin/member/audit",
        method: "post",
        data: data
      });
    },
    cancelMember: function cancelMember() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "api/v1/admin/member/cancel",
        method: "post",
        data: data
      });
    },
    getMemberOrderList: function getMemberOrderList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/order/getMember",
        method: "get",
        params: data
      });
    },
    memberRefund: function memberRefund() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v1/admin/member/order/refund",
        method: "post",
        data: data
      });
    },
    getMemberRefund: function getMemberRefund() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v1/admin/member/order/refund",
        method: "get",
        params: data
      });
    }
  };
});